import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetLevelList = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/levels?GetAll=true`,
        })
    } catch (e) {
        console.error(e)
    }
}
